/**
 * Frontend-only demo mode (no backend required).
 * Set REACT_APP_OFFLINE_MODE=false and provide an API URL to use a real backend.
 */
export const OFFLINE_MODE =
  process.env.REACT_APP_OFFLINE_MODE === undefined
    ? true
    : String(process.env.REACT_APP_OFFLINE_MODE).toLowerCase() !== "false";

export function isOfflineMode() {
  if (typeof window !== "undefined") {
    const params = new URLSearchParams(window.location.search);
    if (params.get("online") === "1") return false;
    if (params.get("offline") === "1") return true;
  }
  return OFFLINE_MODE;
}

const STORAGE_KEY = "VISHWAS_API_BASE_URL";

function trimSlash(url) {
  return String(url || "").trim().replace(/\/$/, "");
}

function readQueryOverride() {
  if (typeof window === "undefined") return "";
  try {
    const params = new URLSearchParams(window.location.search);
    const api = params.get("api");
    if (api) {
      const cleaned = trimSlash(api);
      window.localStorage.setItem(STORAGE_KEY, cleaned);
      return cleaned;
    }
  } catch {
    /* ignore */
  }
  return "";
}

export function getBackendApiBaseUrl() {
  if (isOfflineMode()) return "offline://local";

  const fromQuery = readQueryOverride();
  if (fromQuery) return fromQuery;

  if (typeof window !== "undefined") {
    try {
      const stored = window.localStorage.getItem(STORAGE_KEY);
      if (stored !== null && String(stored).trim() !== "") {
        return trimSlash(stored);
      }
    } catch {
      /* ignore */
    }

    if (window.__VISHWAS_API_BASE_URL__) {
      return trimSlash(window.__VISHWAS_API_BASE_URL__);
    }
  }

  const fromEnv = process.env.REACT_APP_API_BASE_URL;
  if (fromEnv !== undefined && fromEnv !== null && String(fromEnv).trim() !== "") {
    return trimSlash(fromEnv);
  }

  if (typeof window !== "undefined") {
    const host = window.location.hostname;
    if (host === "localhost" || host === "127.0.0.1") {
      return "http://localhost:8000";
    }
    return "";
  }

  return "http://localhost:8000";
}

export function setBackendApiBaseUrl(url) {
  const cleaned = trimSlash(url);
  if (typeof window !== "undefined") {
    if (cleaned) {
      window.localStorage.setItem(STORAGE_KEY, cleaned);
    } else {
      window.localStorage.removeItem(STORAGE_KEY);
    }
  }
  return cleaned;
}

export function describeApiError(error, apiPath = "") {
  if (isOfflineMode()) {
    return (
      error?.response?.data?.message ||
      error?.message ||
      "Something went wrong while saving locally."
    );
  }

  const base = getBackendApiBaseUrl();
  const target = `${base || "(same origin)"}${apiPath}`;
  const status = error?.response?.status;
  const apiMsg = error?.response?.data?.message;
  const raw = error?.message || String(error);

  if (!error?.response && /Failed to fetch|Network Error|ERR_CONNECTION|ECONNREFUSED/i.test(raw)) {
    return [
      "Cannot reach the backend API (Failed to fetch).",
      `Tried: ${target}`,
    ].join("\n");
  }

  if (apiMsg) return `${apiMsg}${status ? ` (HTTP ${status})` : ""}\nAPI: ${target}`;
  return `${raw}${status ? ` (HTTP ${status})` : ""}\nAPI: ${target}`;
}

export const BACKEND_API_BASE_URL = {
  toString() {
    return getBackendApiBaseUrl();
  },
  valueOf() {
    return getBackendApiBaseUrl();
  },
  [Symbol.toPrimitive]() {
    return getBackendApiBaseUrl();
  },
};

export const BACKEND_IMG_API_BASE_URL =
  "https://res.cloudinary.com/dfqczollw/image/upload/";

export const additionalLogging = true;

export const CLOUD_NAME = "dfqczollw";
export const CLOUD_PRESET = "img_vishvaspower";

export const TESTING_DEPARTMENT = false;
